
import { SubDomain } from "../SubDomain.js";
import Card from "./Card.js";

export default class CardsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Card.MODEL_NAME);
    this._storage = storage;
  }
  
  list() {
    return this._storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Card(this.domain, item);
      }
    }

    return new Card(this.domain, {});
  }
  
}